// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Lock = function Lock(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M12 6.363V4.631a3.7 3.7 0 00-1.263-2.552 4.176 4.176 0 00-5.467 0A3.7 3.7 0 004 4.631v1.732H2v8.577h12.125V6.363H12zm-3.327 4.43v2.12H7.326v-2.12a1.33 1.33 0 111.346 0zM5.72 6.363V4.719a1.972 1.972 0 01.683-1.351 2.459 2.459 0 013.191 0 1.974 1.974 0 01.683 1.351v1.644z"
    }))
  );
};

export default Lock;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Lock.js
// module id = 1027
// module chunks = 0